import React from 'react';
import { Shield } from 'lucide-react';

const RISK_LEVELS = [
  { max: 1, label: 'Conservative', color: 'text-green-500', bg: 'bg-green-500/10' },
  { max: 2, label: 'Moderate', color: 'text-blue-500', bg: 'bg-blue-500/10' },
  { max: 3, label: 'Aggressive', color: 'text-yellow-500', bg: 'bg-yellow-500/10' },
  { max: Infinity, label: 'High Risk', color: 'text-red-500', bg: 'bg-red-500/10' },
];

function getRiskLevel(percent) {
  return RISK_LEVELS.find(level => percent < level.max) || RISK_LEVELS[RISK_LEVELS.length - 1];
}

const RiskPerTradeWidget = ({ metrics }) => {
  if (!metrics) return null;

  const { avg_risk_per_trade } = metrics;
  const level = getRiskLevel(avg_risk_per_trade);

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 rounded-lg bg-primary/10">
          <Shield className="w-4 h-4 text-primary" />
        </div>
        <h3 className="text-sm font-semibold text-foreground">Risk Per Trade</h3>
      </div>

      <div className="space-y-3">
        <div className="flex items-baseline gap-2">
          <span className={`text-2xl font-bold font-mono tabular-nums tracking-tight ${level.color}`}>
            {avg_risk_per_trade.toFixed(2)}%
          </span>
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${level.bg} ${level.color}`}>
            {level.label}
          </span>
        </div>

        <p className="text-xs text-muted-foreground leading-relaxed">
          Average loss per trade as a percentage of your equity at the time of the trade.
        </p>

        {/* Risk Level Scale */}
        <div className="flex gap-0.5 h-1.5 rounded-full overflow-hidden">
          <div className="flex-1 bg-green-500/30 rounded-l-full" />
          <div className="flex-1 bg-blue-500/30" />
          <div className="flex-1 bg-yellow-500/30" />
          <div className="flex-1 bg-red-500/30 rounded-r-full" />
        </div>
        <div className="flex justify-between text-[10px] text-muted-foreground">
          <span>0%</span>
          <span>1%</span>
          <span>2%</span>
          <span>3%+</span>
        </div>
      </div>
    </div>
  );
};

export default RiskPerTradeWidget;
